<template>
    <div class="paging-box">
        <el-pagination
            class="paging"
            background
            layout="prev, pager, next"
            @current-change="changePage"
            :page-size="pageSize"
            :current-page="pageNo"
            :total="totalCount"
        ></el-pagination>
    </div>
</template>

<!-- 分页 -->

<script>
export default {
  props: {
    pageSize: {
      type: Number,
      default: 5
    },
    pageNo: {
      type: Number,
      default: 1
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    changePage (pageNo) {
      this.$emit('changePage', pageNo)
    }
  }
}
</script>

<style lang="scss" scoped>
.paging-box {
    max-width: 1200px;
    min-width: 800px;
    display: flex;
    justify-content: flex-end;
}
.paging {
    width: fit-content;
    margin:30px 0 100px 0;
    // margin: 50px auto 100px auto;
    // & /deep/ .el-pager li {
    //     background-color: #fff !important;
    //     border: 1px solid $main-color;
    //     border-radius: 6px !important;
    //     font-weight: 400;
    //     color: $main-color !important;
    // }
    // & /deep/ .btn-prev,
    // & /deep/ .btn-next {
    //     background-color: #fff !important;
    //     border: 1px solid $main-color;
    //     border-radius: 8px !important;
    //     color: $main-color !important;
    // }
    // & /deep/ .btn-prev:disabled,
    // & /deep/ .btn-next:disabled {
    //     border-color: $main-color;
    //     background-color: #f4f4f5 !important;
    //     color: #606266 !important;
    //     border: none;
    // }
    // & /deep/ .el-pager li.active {
    //     background-color: $main-color !important;
    //     color: #fff !important;
    // }
}
</style>
